import { createRouter, createWebHashHistory } from "vue-router";
import store from '@/store/index.js';

import Login from "@/views/auth/Login.vue";
import Signup from "@/views/auth/Signup.vue";
import Dashboard from "@/views/Dashboard.vue";
import Profile from "@/views/auth/Profile.vue";
import ChangePlant from "@/views/auth/ChangePlant.vue";
import ForgotPassword from "@/views/auth/ForgotPassword.vue";
import ResetPassword from "@/views/auth/ResetPassword.vue";


// configuration
import EquipmentVue from "@/views/masters/Equipments.vue";
import CreateAsset from "@/views/masters/assets/Create.vue";
import EditAsset from "@/views/masters/assets/Edit.vue";
import Assets from "@/views/masters/assets/Index.vue";
import AssetView from "@/views/masters/assets/ViewAsset.vue";
import GenerateQR from "@/views/masters/assets/GenerateQRCode.vue"

// asset template
import AssetTemplates from "@/views/masters/assetTemplate/Index.vue";
import CreateAssetTemplates from "@/views/masters/assetTemplate/Create.vue";
import AssetTemplateView from "@/views/masters/assetTemplate/ViewAssetTemplate.vue";

//Registers
import Activities from "@/views/registers/activity/Index.vue";
import CreateActivity from "@/views/registers/activity/Create.vue";

// User Services
import UserServices from "@/views/registers/user_services/Index.vue";
import CreateUserService from "@/views/registers/user_services/Create.vue";

// Inward Spare
import InwardSpares from "@/views/registers/inward_spares/index.vue";
import CreateInwardSpare from "@/views/registers/inward_spares/create.vue";

//User checks
import UserChecks from "@/views/registers/check_register/user_checks/Index.vue";
import CreateUserCheck from "@/views/registers/check_register/user_checks/Create.vue";
import ViewUserCheck from "@/views/registers/check_register/user_checks/View.vue";

// Lineage parameter
import ClusterVue from "@/views/lineage_parameters/Cluster.vue";
import PlantsVue from "@/views/lineage_parameters/Plants.vue";
import Section from "@/views/lineage_parameters/Section.vue";
import Frequency from "@/views/lineage_parameters/Frequency.vue";
import Department from "@/views/lineage_parameters/Department.vue";

//List params

//import Check from "@/views/list_params/Check.vue";
import Spare from "@/views/list_parameters/Spare.vue";
import CreateCheck from "@/views/list_parameters/checks/Create.vue";
import IndexChecks from "@/views/list_parameters/checks/Index.vue";
import Service from "@/views/list_parameters/Service.vue";


// user management
import Role from "@/views/userManagement/Role.vue";
import CreateUser from "@/views/userManagement/users/Create.vue"
import Users from "@/views/userManagement/users/Index.vue";
import Permissions from "@/views/userManagement/Permissions.vue";


//Reports
import Deviations from "@/views/reports/Deviations.vue";
import CompletedDeviations from "@/views/reports/CompletedDeviations.vue";
import Pendings from "@/views/reports/Pendings.vue";
import UpcomingJobs from "@/views/reports/UpcomingJobs.vue";

import PendingJobs from "@/views/reports/PendingJobs.vue";
import InventoryReport from "@/views/reports/InventoryReport.vue";
import SpareLedger from "@/views/reports/SpareLedger.vue";
import DeviationReport from "@/views/reports/DeviationReport.vue";
import AssetReport from "@/views/reports/AssetReport.vue";
import AssetReportView from "@/views/reports/ViewAssetReport.vue";

//Asset management
import Components from "@/views/assets/Index.vue";
import ComponentCreate from "@/views/assets/Create.vue";
import AssetActivityVue from "@/views/assets/AssetActivity.vue";
import ServiceVue from "@/views/assets/Service.vue";
import InhouseServiceVue from "@/views/assets/InhouseService.vue";

// Type parameters
import EquipmentTypeVue from "@/views/type_parameters/EquipmentType.vue";
import AssetTypeVue from "@/views/type_parameters/AssetType.vue";
import ServiceTypeVue from "@/views/type_parameters/ServiceType.vue";
import SpareTypes from "@/views/type_parameters/SpareTypes.vue";
import ReasonVue from "@/views/type_parameters/Reason.vue";

//Spares

import ScheduledMaintenanceVue from "@/views/assets/ScheduledMaintenance.vue";
//import { CreateChecks } from '@/views/list_parameters/CreateUser.vue';


// Motor Parameters
//import Voltage from ';

//Asset Parameters
import CreateAssetParameter from "@/views/asset_parameters/Create.vue"
import AssetParameters from "@/views/asset_parameters/Index.vue";

// downloaded reports
import DownloadedReports from "@/views/DownloadedReports.vue"

// Error
import Error from '@/views/Error.vue'


const routes = [
  {
    path: "/",
    name: "login",
    component: Login,
    meta: { unAuth: true, permission: 'All' }
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
    meta: { unAuth: true, permission: 'All' }
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { auth: true, permission: 'All' }
  },
  {
    path: "/change_plant",
    name: "ChangePlant",
    component: ChangePlant,
    meta: { auth: true, permission: 'All', role: "Super Admin",}
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { auth: true, permission: 'All' }
  },
  {
    path: "/forgot_password",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: { unAuth: true, permission: 'All' }
  },
  {
    path: "/reset_password",
    name: "ResetPassword",
    component: ResetPassword,
    meta: { unAuth: true, permission: 'All' }
  },


  {
    path: "/permissions",
    name: "Permissions",
    component: Permissions,
    meta: { auth: true, permission: 'permissions.view'}
  },

  // Type parameters
  {
    path: "/equipment_types",
    name: "EquipmentType",
    component: EquipmentTypeVue,
    meta: { auth: true, permission: 'equipment_types.view' }
  },
  {
    path: "/asset_types",
    name: "AssetType",
    component: AssetTypeVue,
    meta: { auth: true, permission: 'asset_types.view' }
  },
  {
    path: "/service_types",
    name: "ServiceType",
    component: ServiceTypeVue,
    meta: { auth: true, permission: 'service_types.view' }
  },
  {
    path: "/spare_types",
    name: "SpareType",
    component: SpareTypes,
    meta: { auth: true, permission: 'spare_types.view' }
  },
  {
    path: "/reasons",
    name: "Reason",
    component: ReasonVue,
    meta: { auth: true, permission: 'reasons.view' }
  },


  // configuration
  {
    path: "/section",
    name: "Section",
    component: Section,
    meta: { auth: true, permission: 'sections.view' }
  },
  {
    path: "/clusters",
    name: "Cluster",
    component: ClusterVue,
    meta: { auth: true, permission: 'clusters.view' }
  },
  {
    path: "/plants",
    name: "Plant",
    component: PlantsVue,
    meta: { auth: true, permission: 'plants.view' }
  },

  //Frequency
  {
    path: "/frequency",
    name: "Frequency",
    component: Frequency,
    meta: { auth: true, permission: 'frequencies.view' }
  },
  {
    path: "/department",
    name: "Department",
    component: Department,
    meta: { auth: true, permission: 'departments.view' }
  },


  //masters
  {
    path: "/equipment",
    name: "Equipment",
    component: EquipmentVue,
    meta: { auth: true, permission: 'equipment.view' }
  },
  {
    path: "/assets",
    name: "Assets",
    component: Assets,
    meta: { auth: true, permission: 'assets.view' }
  },
  {
    path: "/asset/create",
    name: "Assets.Create",
    component: CreateAsset,
    meta: { auth: true, permission: 'All' }
  },
  // {
  //   path: "/asset/:asset_id/edit",
  //   name: "Assets.Edit",
  //   component: EditAsset,
  // },
  {
    path: "/asset/:asset_id/edit",
    name: "Assets.Edit",
    component: CreateAsset,
    meta: { auth: true, permission: 'All' }
  },
  {
    path: "/asset/:asset_id/view",
    name: "Assets.View",
    component: AssetView,
    meta: { auth: true, permission: 'All' }
  },
  {
    path: "/QR_code/:asset_id/get",
    name: "GenerateQR",
    component: GenerateQR,
    meta: { auth: true, permission: 'All' }
  },
  // {
  //   path: "/spares",
  //   name: "Asset.Spare",
  //   component: SpareVue,
  // },

  // asset template
  {
    path: "/asset_templates",
    name: "AssetTemplates",
    component: AssetTemplates,
    meta: { auth: true, permission: 'asset_templates.view' }
  },
  {
    path: "/asset_template/create",
    name: "AssetTemplates.Create",
    component: CreateAssetTemplates,
    meta: { auth: true, permission: 'All' }
  },
  {
    path: "/asset_templates/:asset_template_id/edit",
    name: "AssetTemplates.Edit",
    component: CreateAssetTemplates,
    meta: { auth: true, permission: 'All' }
  },
  {
    path: "/asset_templates/:asset_template_id/view",
    name: "AssetTemplates.View",
    component: AssetTemplateView,
    meta: { auth: true, permission: 'All' }
  },

  //registers
  {
    path: "/activities",
    name: "Activities.Index",
    component: Activities,
    meta: { auth: true, permission: 'activity_registers.view' }
  },
  {
    path: "/activity/create",
    name: "Activity.Create",
    component: CreateActivity,
    meta: { auth: true, permission: 'All' }
  },
  {
    path: "/activity/:user_activity_id/edit",
    name: "Activity.Edit",
    component: CreateActivity,
    meta: { auth: true, permission: 'All' }
  },

  //User Services
  {
    path: "/user_services",
    name: "UserServices.Index",
    component: UserServices,
    meta: { auth: true, permission: 'service_registers.view' }
  },
  {
    path: "/user_service/create",
    name: "UserServices.Create",
    component: CreateUserService,
    meta: { auth: true, permission: 'All' }
  },

  {
    path: "/user_service/:user_service_id/edit",
    name: "UserServices.Edit",
    component: CreateUserService,
    meta: { auth: true, permission: 'All' }
  },

   //InwardSpares
  {
    path: "/inward_spares",
    name: "InwardSpares.Index",
    component: InwardSpares,
    meta: { auth: true, permission: 'inward_spare_register.view' }
  },

  {
    path: "/inward_spares/create",
    name: "InwardSpares.Create",
    component: CreateInwardSpare,
    meta: { auth: true, permission: 'inward_spare_register.create' }
  },

  {
    path: "/inward_spares/:inward_id/edit",
    name: "InwardSpares.Edit",
    component: CreateInwardSpare,
    meta: { auth: true, permission: 'inward_spare_register.update' }
  },

  //User Checks
  {
    path: "/user_checks",
    name: "UserChecks.Index",
    component: UserChecks,
    meta: { auth: true, permission: 'check_registers.view' }
  },
  {
    path: "/user_check/create",
    name: "UserChecks.Create",
    component: CreateUserCheck,
    meta: { auth: true, permission: 'All' }
  },
  {
    path: "/user_check/:user_check_id/edit",
    name: "UserChecks.Edit",
    component: CreateUserCheck,
    meta: { auth: true, permission: 'All' }
  },
  {
    path: "/user_check/:user_check_id/view",
    name: "UserChecks.View",
    component: ViewUserCheck,
    meta: { auth: true, permission: 'All' }
  },

  // list params
  {
    path: "/checks",
    name: "checks.Index",
    component: IndexChecks,
    meta: { auth: true, permission: 'checks.view' }
  },
  {
    path: "/checks/create",
    name: "CheckCreate",
    component: CreateCheck,
    meta: { auth: true, permission: 'All' }
  },

  {
    path: "/checks/:check_id/edit",
    name: "Checks.Edit",
    component: CreateCheck,
    meta: { auth: true, permission: 'All' }
  },

  {
    path: "/spares",
    name: "Spares",
    component: Spare,
    meta: { auth: true, permission: 'spares.view' }
  },

  {
    path: "/services",
    name: "Services",
    component: Service,
    meta: { auth: true, permission: 'services.view' }
  },

  // Component Management
  {
    path: "/components",
    name: "Componet.Index",
    component: Components,
    meta: { auth: true, permission: 'assets.view' }
  },
  {
    path: "/components/create",
    name: "Componet.Create",
    component: ComponentCreate,
    meta: { auth: true, permission: 'All' }
  },
  {
    path: "/components/service",
    name: "Componet.Service",
    component: ServiceVue,
    meta: { auth: true, permission: 'All' }
  },
  {
    path: "/components/inhouse_service",
    name: "Componet.Service2",
    component: InhouseServiceVue,
    meta: { auth: true, permission: 'All' }
  },
  {
    path: "/components/maintenance",
    name: "Componet.Maintenance",
    component: ScheduledMaintenanceVue,
    meta: { auth: true, permission: 'All' }
  },
  {
    path: "/assets/activity",
    name: "Asset.Activity",
    component: AssetActivityVue,
    meta: { auth: true, permission: 'All' }
  },
  // user management
  {
    path: "/role",
    name: "Role",
    component: Role,
    meta: { auth: true, permission: 'roles.view' }
  },
  // users
  {
    path: "/users",
    name: "Users.Index",
    component: Users,
    meta: { auth: true, permission: 'users.view' }
  },
  {
    path: "/user/create",
    name: "Users.Create",
    component: CreateUser,
    meta: { auth: true, permission: 'All' }
  },

  {
    path: "/users/:user_id/edit",
    name: "Users.Edit",
    component: CreateUser,
    meta: { auth: true, permission: 'All' }
  },

  //Asset Parameters
  {
    path: "/asset_parameters",
    name: "AssetParameters.Index",
    component: AssetParameters,
    meta: { auth: true, permission: 'assetParameters.view' }
  },
  {
    path: "/asset_parameters/create",
    name: "AssetParameters.Create",
    component: CreateAssetParameter,
    meta: { auth: true, permission: 'All' }
  },

  {
    path: "/asset_parameters/:asset_parameter_id/edit",
    name: "AssetParameters.Edit",
    component: CreateAssetParameter,
    meta: { auth: true, permission: 'All' }
  },

  //Deviation
  {
    path: "/deviations",
    name: "Deviations.Index",
    component: Deviations,
    meta: { auth: true, permission: 'All' }
  },
  {
    path: "/completed_deviations",
    name: "CompletedDeviations",
    component: CompletedDeviations,
    meta: { auth: true, permission: 'All' }
  },

  {
    path: "/pendings",
    name: "Pendings.Index",
    component: Pendings,
    meta: { auth: true, permission: 'All' }
  },

  {
    path: "/upcomingjobs",
    name: "UpcomingJobs.Index",
    component: UpcomingJobs,
    meta: { auth: true, permission: 'All' }
  },
  {
    path: "/pending_jobs",
    name: "PendingJobs.Index",
    component: PendingJobs,
    meta: { auth: true, permission: 'job_pending_report' }
  },
  {
    path: "/deviation_reports",
    name: "DeviationReport.Index",
    component: DeviationReport,
    meta: { auth: true, permission: 'deviation_report' }
  },

  {
    path: "/inventory_report",
    name: "InventoryReport.Index",
    component: InventoryReport,
    meta: { auth: true, permission: 'inventory_report' }
  },

  {
    path: "/spare_ledger_report",
    name: "SpareLedger.Index",
    component: SpareLedger,
    meta: { auth: true, permission: 'spare_ledger_report' }
  },

  {
    path: "/asset_reports",
    name: "AssetReport.Index",
    component: AssetReport,
    meta: { auth: true, permission: 'asset_report' }
  },
  {
    path: "/asset_reports/:type/:id/view",
    name: "AssetReportView",
    component: AssetReportView,
    meta: { auth: true, permission: 'All' }
  },

  {
    path: "/downloaded_reports",
    name: "DownloadedReports",
    component: DownloadedReports,
    meta: { auth: true, permission: 'downloaded_reports.view' }
  },
  // error
  {
    path: '/error',
    name: 'Error',
    component: Error,
    meta: { auth: true, permission: 'All' }
  },


]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 }
  },
  //  }
});


router.beforeEach(function (to, _, next) {
  if (to.meta.auth && !store.getters.user) {
    next('/');
  }
  else if (to.meta.unAuth && store.getters.user) {
    next('/dashboard');
  }
  else {
    let permissions = store.getters.permissions;
    
    //for ChangePlant
    const userRole = store.getters.user?.role?.role;
    if (to.meta.role && to.meta.role === 'Super Admin' && userRole !== 'Super Admin') {
      next('/error');
      return;
    }

    if (to.meta.permission == 'All') {
      next();
    }
    else if (permissions.length > 0) {
      let permission = permissions.filter(function (el) {
        return el.ability.ability == to.meta.permission || to.meta.permission == 'All';
      });
      if (permission.length > 0) {
        next();
      }
      else {
        next('/error')
      }
    }
    else {
      next('/error')
    }
  }
});

// router.beforeEach((to, _, next) => {
//   const isAuthenticated = !!store.getters.user;
//   const user = store.getters.user;
//   const userPermissions = store.getters.permissions || [];

//   if (to.meta.auth && !isAuthenticated) {
//     next('/');
//   } else if (to.meta.unAuth && isAuthenticated) {

//     next('/dashboard');
//   } else if (to.meta.role && user.role.role !== to.meta.role) {

//     next('/error');
//   } else if (to.meta.permission === 'All') {
//     next();
//   } else {
//     const hasPermission = userPermissions.some(
//       (perm) => perm.ability.ability === to.meta.permission
//     );

//     if (hasPermission) {
//       next();
//     } else {
//       next('/error');
//     }
//   }
// });


export default router
